
export default function validLocale({ to, next, router }) {
  if(!['en','es','pt-pt'].includes(to.params.lang) && to.params.lang !== ''){
    return router.replace('/' + to.name)
  }

  return next()
}
